import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);


const routes = [
    { path: '/', component: () => import("../pages/nsuk/components/Registration.vue") },
    { path: '/application', component: () => import("../pages/nsuk/components/Application.vue")},
    { path: '/dashboard', component: () => import("../pages/nsuk/components/Dashboard.vue")},
    { path: '/change-program', component: () => import("../pages/nsuk/components/Program.vue")},
    { path: '/data-correction', component: () => import("../pages/nsuk/components/Data-Correction.vue") },
    { path: '/verify', component: () => import("../pages/nsuk/components/Verification.vue") },
];



export default new VueRouter({
    routes
})
